import React, { Component, Fragment } from "react";

export default class NovoForm extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {}
        }

    }

    voltar = () => {
        window.location = window.location.pathname.slice(0, window.location.pathname.lastIndexOf("/"))
    }

    render() {
        let { unidade, metas } = this.props;
        let meses = ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa/ZEUS"];
        let name = ["numeroAtendimento", "horasTecnicas", "receita", "despesa"];

        return (
            <Fragment>
            <div className="content">
                <div className="row">
                    <div className="col-md-12 ml-auto mr-auto">
                        <div className="card card-user">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3 className="text-uppercase m-2">{unidade}</h3>
                                        <h6 className="text-uppercase m-2">{this.props.produto}</h6>
                                        <button className="btn btn-btn-danger btn-round" onClick={() => this.voltar()}>Voltar</button>

                                        {/*<div className="table table-striped table-hover table-sm table-responsive table-borderless">*/}
                                        <div className="table table-striped table-hover table-borderless table-sm">
                                            <form onSubmit={this.props.onSubmit} id="formMetasMensaisSTI">
                                                
                                                {this.props.children}
                                                
                                                <div className="row">
                                                    <div className="update ml-auto mr-auto m-2">
                                                        <button type="submit" className="btn btn-primary btn-round">Cadastrar</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </Fragment>
        )
    }
}